import styled from 'styled-components';

export const ResultsContainer = styled.div`
	height: 100%;
	display: flex;
	padding: 2rem;
	border-radius: 0.5rem;
	flex-direction: column;
	justify-content: center;
	background-color: white;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
`;

export const KinebotLogoContainer = styled.div``;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 1rem;
	font-weight: 400;

	#title {
		font-weight: 600;
	}
`;

export const ClientLogoContainer = styled.div`
	background: #d9d9d9;
	width: 100%;
	height: 100%;
	border-radius: 0.5rem;
	padding: 0.75rem 0.5rem;
	text-align: center;

	span {
		color: #8c8c8c;
		font-size: 1rem;
		font-weight: 600;
	}
`;

export const Topic = styled.span`
	font-size: 0.9rem;
	font-weight: 600;
	margin-right: 0.5rem;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const Value = styled.span`
	font-size: 0.9rem;
	font-weight: 400;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const PercentileScoreContainer = styled.span`
	color: #2f54eb;
	font-weight: 600;
	font-size: 0.9rem;
	border-radius: 0.25rem;
	padding: 0.75rem 1rem;
	border: 1px solid #2f54eb;
	background-color: #2f54eb0d;
`;
